<template>
  <div
    v-if="authorSection.isVisible"
    :class="[authorSection.isVisible ? 'space-y-5 py-10' : '']"
    class="flex flex-col justify-center items-center"
    :style="`background-color: ${authorSection.backgroundColor}`"
  >
    <img
      v-if="authorSection.profile_image"
      :src="authorSection.profile_image"
      alt="Avatar"
      class="h-32 w-32 rounded-full"
    />
    <div
      v-show="authorSection.name"
      :style="`color: ${authorSection.textColor}`"
      class="text-2xl text-dark font-semibold"
    >
      {{ authorSection.name }}
    </div>
    <div
      v-if="authorSection.description"
      :style="`color: ${authorSection.textColor}; margin-top: 10px`"
      class="
        text-md
        leading-relaxed
        font-dark
        text-center
        2xl:px-96
        xl:px-96
        lg:px-96
        md:px-96
        sm:px-40
        xs:px-20
        px-10
      "
      v-html="authorSection.description"
    ></div>
    <div
      class="flex flex-row space-x-3"
      :style="`color: ${authorSection.social_color};`"
      v-if="
        authorSection.facebook_link ||
        authorSection.instagram_link ||
        authorSection.linkedin_link ||
        authorSection.youtube_link
      "
    >
      <span v-if="authorSection.facebook_link">
        <a :href="authorSection.facebook_link" target="_blank"
          ><i class="fab fa-facebook-square" :style="`font-size: 25px`"></i
        ></a>
      </span>
      <span v-if="authorSection.instagram_link">
        <a :href="authorSection.instagram_link" target="_blank"
          ><i class="fab fa-instagram-square" :style="`font-size: 25px`"></i
        ></a>
      </span>
      <span v-if="authorSection.linkedin_link">
        <a :href="authorSection.linkedin_link" target="_blank"
          ><i class="fab fa-linkedin" :style="`font-size: 25px`"></i
        ></a>
      </span>
      <span v-if="authorSection.youtube_link">
        <a :href="authorSection.youtube_link" target="_blank"
          ><i class="fab fa-youtube-square" :style="`font-size: 25px`"></i
        ></a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Author',
  props: {
    authorSection: {},
  },
};
</script>
